export default __webpack_public_path__ + "static/media/avatar_default.d18be4c8.png";